import React from 'react';

class RemoteControlIcon extends React.Component {
  state = {
    direction: this.props.direction
  };
  render() {
    return (
      <React.Fragment>
        {this.state.direction === 'top' && (
          <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M29 29V22H31V29H38V31H31V38H29V31H22V29H29Z"
              fill="#8A8B8D"
            />
          </svg>
        )}
        {this.state.direction === 'left' && (
          <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36.0556 22.0589C35.8653 22.1548 35.6115 22.3123 35.1952 22.5725L23.8141 29.6857C23.4376 29.9209 23.2142 30.0618 23.0638 30.176C23.0553 30.1825 23.0473 30.1887 23.04 30.1945C23.0473 30.2002 23.0553 30.2064 23.0638 30.2129C23.2142 30.3272 23.4376 30.468 23.8141 30.7033L35.1952 37.8165C35.6115 38.0766 35.8653 38.2341 36.0556 38.3301C36.0675 38.3361 36.0786 38.3415 36.089 38.3465C36.0903 38.3351 36.0915 38.3228 36.0927 38.3095C36.1122 38.0973 36.1132 37.7986 36.1132 37.3077V23.0813C36.1132 22.5904 36.1122 22.2916 36.0927 22.0794C36.0915 22.0661 36.0903 22.0538 36.089 22.0424C36.0786 22.0474 36.0675 22.0528 36.0556 22.0589ZM35.1549 20.2731C35.4397 20.1295 35.8266 19.9692 36.2735 20.0051C36.8482 20.0513 37.375 20.3433 37.7188 20.8062C37.9861 21.1661 38.0552 21.5792 38.0844 21.8968C38.1133 22.2117 38.1132 22.6042 38.1132 23.0384V37.3505C38.1132 37.7847 38.1133 38.1772 38.0844 38.4922C38.0552 38.8097 37.9861 39.2228 37.7188 39.5827C37.375 40.0456 36.8482 40.3376 36.2735 40.3838C35.8266 40.4197 35.4396 40.2594 35.1549 40.1158C34.8725 39.9733 34.5397 39.7653 34.1714 39.5351L22.7193 32.3775C22.3893 32.1713 22.0861 31.9818 21.8538 31.8053C21.614 31.6231 21.3263 31.3664 21.1617 30.9823C20.9461 30.4792 20.9461 29.9097 21.1617 29.4066C21.3263 29.0225 21.614 28.7658 21.8538 28.5836C22.0861 28.4071 22.3893 28.2176 22.7193 28.0114L34.1715 20.8538C34.5397 20.6236 34.8725 20.4156 35.1549 20.2731Z"
              fill="#8A8B8D"
            />
          </svg>
        )}
        {this.state.direction === 'right' && (
          <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.9444 22.0588C23.1347 22.1548 23.3885 22.3122 23.8048 22.5724L35.1859 29.6856C35.5624 29.9209 35.7858 30.0617 35.9362 30.176C35.9447 30.1825 35.9527 30.1886 35.96 30.1944C35.9527 30.2002 35.9447 30.2064 35.9362 30.2129C35.7858 30.3271 35.5624 30.468 35.1859 30.7032L23.8048 37.8164C23.3885 38.0766 23.1347 38.2341 22.9444 38.33C22.9325 38.336 22.9214 38.3415 22.911 38.3465C22.9097 38.3351 22.9085 38.3227 22.9073 38.3094C22.8878 38.0973 22.8868 37.7985 22.8868 37.3076V23.0812C22.8868 22.5903 22.8878 22.2916 22.9073 22.0794C22.9085 22.0661 22.9097 22.0538 22.911 22.0424C22.9214 22.0473 22.9325 22.0528 22.9444 22.0588ZM23.8451 20.2731C23.5603 20.1295 23.1734 19.9692 22.7265 20.0051C22.1518 20.0513 21.625 20.3433 21.2812 20.8062C21.0139 21.1661 20.9448 21.5792 20.9156 21.8967C20.8867 22.2117 20.8868 22.6041 20.8868 23.0384V37.3504C20.8868 37.7847 20.8867 38.1772 20.9156 38.4921C20.9448 38.8097 21.0139 39.2228 21.2812 39.5827C21.625 40.0456 22.1518 40.3375 22.7265 40.3838C23.1734 40.4197 23.5604 40.2594 23.8451 40.1158C24.1275 39.9733 24.4603 39.7653 24.8286 39.5351L36.2807 32.3775C36.6107 32.1713 36.9139 31.9818 37.1462 31.8053C37.386 31.6231 37.6737 31.3664 37.8383 30.9822C38.0539 30.4792 38.0539 29.9097 37.8383 29.4066C37.6737 29.0225 37.386 28.7658 37.1462 28.5836C36.9139 28.4071 36.6107 28.2176 36.2807 28.0114L24.8285 20.8538C24.4603 20.6236 24.1275 20.4155 23.8451 20.2731Z"
              fill="#8A8B8D"
            />
          </svg>
        )}
        {this.state.direction === 'bottom' && (
          <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M38 31V29H22V31H38Z" fill="#8A8B8D" />
          </svg>
        )}
      </React.Fragment>
    );
  }
}

export default RemoteControlIcon;
